// @flow
export { default } from './SavePostCard';



// WEBPACK FOOTER //
// ./src/components/saves/SavePostCard/index.js